function appendElem (el, binding) {
  const mask = el.loadingElement
  // 如果是全屏加载则设置mask的位置
  if (binding.modifyiers.isFullscreen) {
    mask.style.top = binding.arg || 0
    mask.style.position = 'fixed'
    document.body.appendChild(mask)
    return
  }
  el.appendChild(mask)
}

function removeElem (el, binding) {
  const parentNode = el.loadingElement.parentNode
  if (!(el === parentNode || document.body === parentNode)) return
  const mask = el.loadingElement
  if (binding.modifyiers.isFullscreen) {
    document.body.removeChild(mask)
    return
  }
  el.removeChild(mask)
}

export default {
  bind: (el, binding) => {
    const mask = document.createElement('div')
    mask.className = 'loading-mask'
    const icon = document.createElement('div')
    icon.className = 'loading-icon'
    mask.appendChild(icon)
    el.loadingElement = mask
    const position = (getComputedStyle(el) || {}).position
    el.style.position = position === 'absolute' ? position : 'relative'
    if (binding.value) {
      appendElem(el, binding)
    }
  },

  update: (el, binding) => {
    if (binding.value) {
      if (el.loadingElement.parentNode === null) {
        appendElem(el, binding)
      }
      return
    }
    removeElem(el, binding)
  },

  unbind: (el, binding) => {
    removeElem(el, binding)
    el.loadingElement = null
  }
}



// WEBPACK FOOTER //
// ./src/assets/directive/loading.js